define('pwa/view/controller/dashboard/suggested-booking/DashboardSuggestedBookingListView',['require','marionette','pwa/view/controller/dashboard/suggested-booking/DashboardSuggestedBookingItemView','pwa/view/controller/dashboard/suggested-booking/DashboardSuggestedBookingEmptyView'],function (require) {

    var Marionette = require('marionette');
    var DashboardSuggestedBookingItemView = require('pwa/view/controller/dashboard/suggested-booking/DashboardSuggestedBookingItemView');
    var DashboardSuggestedBookingEmptyView = require('pwa/view/controller/dashboard/suggested-booking/DashboardSuggestedBookingEmptyView');

    /**
     * @class DashboardSuggestedBookingListView
     */
    return Marionette.CollectionView.extend({

        childView: DashboardSuggestedBookingItemView,
        emptyView: DashboardSuggestedBookingEmptyView,

        collectionEvents: {
            'sync': 'render'
        },

    });

});
